const formatCurrency = (value, currency = 'BRL', region = 'pt-BR') => {
    const newValue = String(value);
    const numberValue = parseFloat(newValue.replace(/[^\d,.-]/g, '').replace(',', '.'));
    return new Intl.NumberFormat(region, {
      style: 'currency',
      currency: currency,
    }).format(numberValue || 0);
}

export { formatCurrency }